(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-locator"] && !Shopify.designMode) return;
  try {
    const StoreLocator = {
 stores: [
  { title: "Bellmore", position: [40.6629, -73.5287], address: "2572 Merrick Road, Bellmore, New York 11710, United States" ,        phone:"516-809-7370"
 },
  { title: "Huntington", position: [40.8715, -73.4257], address: "24 Wall Street, Huntington, New York 11743, United States" ,        phone:"631-824-6180"
},
  { title: "Plainview", position: [40.7859, -73.4673], address: "164 Manetto Hill Rd, Plainview, New York 11803, United States" ,        phone:"516-513-0598"
},
  { title: "Garden City", position: [40.7260, -73.6343], address: "156 7th St, Garden City, NY 11530, United States" ,        phone:"(516)243-9753"
}
],

  // Bounding box for NYC and Nassau County
  nyBounds: {
    minLat: 40.4,
    maxLat: 41.1,
    minLon: -74.3,
    maxLon: -73.3
  },

  getDistance(lat1, lon1, lat2, lon2) {
    try {
      const R = 6371;
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return (R * c) * 0.621371;
    } catch (error) {
      console.error('Error calculating distance:', error);
      return Infinity;
    }
  },

  renderStoreCards(userLat, userLon) {
    const storeCardsContainer = document.getElementById('modal-store-cards');
    if (!storeCardsContainer) {
      console.error('Store cards container not found');
      return;
    }
    storeCardsContainer.innerHTML = '';

    try {
      const storesWithDistance = this.stores.map(store => ({
        ...store,
        distance: this.getDistance(userLat, userLon, store.position[0], store.position[1])
      })).sort((a, b) => a.distance - b.distance);

      storesWithDistance.forEach(store => {
        const card = document.createElement('div');
        card.className = 'store-card text-black';
        card.dataset.lat = store.position[0];
        card.dataset.lng = store.position[1];
        card.dataset.address = store.address;
        card.dataset.title = store.title;
        card.innerHTML = `
          <h3>${store.title}</h3>
          <div style="display:flex; gap:8px; justify-content:space-between">
            <p class="store-address">${store.address}</p>

            <div style="display:flex; gap:7px;">
              <div style="display:flex; flex-direction:column; align-items:center; width:120px">
                <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.32654 12.145C7.23134 12.2134 7.11708 12.2501 6.99987 12.2501C6.88266 12.2501 6.76841 12.2134 6.67321 12.145C3.85629 10.1372 0.866705 6.00717 3.88896 3.02283C4.71866 2.20666 5.83603 1.74949 6.99987 1.75C8.16654 1.75 9.28596 2.20792 10.1108 3.02225C13.133 6.00658 10.1435 10.136 7.32654 12.145Z" stroke="#656E7D" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.99967 7.00033C7.30909 7.00033 7.60584 6.87741 7.82463 6.65862C8.04342 6.43982 8.16634 6.14308 8.16634 5.83366C8.16634 5.52424 8.04342 5.22749 7.82463 5.0087C7.60584 4.78991 7.30909 4.66699 6.99967 4.66699C6.69026 4.66699 6.39351 4.78991 6.17472 5.0087C5.95592 5.22749 5.83301 5.52424 5.83301 5.83366C5.83301 6.14308 5.95592 6.43982 6.17472 6.65862C6.39351 6.87741 6.69026 7.00033 6.99967 7.00033Z" stroke="#656E7D" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="distance-display">${store.distance.toFixed(2)} mi</div>
              </div>
              
            </div>
            
          </div>
          
                      <p class="store-hours py-3">Phone: <strong> ${store.phone} </strong></p>
        `;
        card.addEventListener('click', () => {
          document.querySelectorAll('.store-card').forEach(c => c.classList.remove('selected'));
          card.classList.add('selected');
          const selectedStore = document.getElementById('selected-store');
          if (selectedStore) {
            selectedStore.textContent = store.title;
          } else {
            console.error('Selected store element not found');
          }
          this.closeModal();
        });
        storeCardsContainer.appendChild(card);
      });
    } catch (error) {
      console.error('Error rendering store cards:', error);
    }
  },

  searchByLocation() {
    const input = document.getElementById('modal-search-input');
    if (!input || !input.value.trim()) {
      alert('Please enter a valid New York zip code (e.g., 10001 or 11710).');
      return;
    }

    // Validate input as a 5-digit zip code
    const zipCodeRegex = /^\d{5}$/;
    if (!zipCodeRegex.test(input.value.trim())) {
      alert('Please enter a valid 5-digit New York zip code.');
      return;
    }

    // Nominatim API with bounding box and New York state restriction
    const bbox = `${this.nyBounds.minLon},${this.nyBounds.minLat},${this.nyBounds.maxLon},${this.nyBounds.maxLat}`;
    fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(input.value.trim())},+New+York,+USA&format=json&limit=1&bounded=1&viewbox=${bbox}&countrycodes=us`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        if (data && data.length > 0) {
          const userLat = parseFloat(data[0].lat);
          const userLon = parseFloat(data[0].lon);

          // Verify location is within the bounding box
          if (
            userLat >= this.nyBounds.minLat &&
            userLat <= this.nyBounds.maxLat &&
            userLon >= this.nyBounds.minLon &&
            userLon <= this.nyBounds.maxLon
          ) {
            this.renderStoreCards(userLat, userLon);
          } else {
            alert('The entered zip code is outside the New York City or Nassau County area. Please try a zip code within this region (e.g., 10001 or 11710).');
          }
        } else {
          alert('Could not find a valid location for this zip code in New York. Please try a different zip code (e.g., 10001 or 11710).');
        }
      })
      .catch(error => {
        alert('Error fetching location data. Please try again.');
        console.error('Search error:', error);
      });
  },

  openModal() {
    const modal = document.getElementById('store-locator-modal');
    if (modal) {
      modal.classList.add('open');
      this.renderStoreCards(40.8715, -73.4257); // Default to Huntington coordinates
      console.log('Modal opened');
    } else {
      console.error('Modal element not found');
    }
  },

  closeModal() {
    const modal = document.getElementById('store-locator-modal');
    if (modal) {
      modal.classList.remove('open');
      console.log('Modal closed');
    } else {
      console.error('Modal element not found');
    }
  },

  init() {
    const changeStoreBtn = document.getElementById('change-store-btn');
    const closeModalBtn = document.getElementById('close-modal-btn');
    const searchStoreBtn = document.getElementById('search-store-btn');

    if (changeStoreBtn) {
      changeStoreBtn.addEventListener('click', () => this.openModal());
    } else {
      console.error('Change store button not found');
    }

    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', () => this.closeModal());
    } else {
      console.error('Close modal button not found');
    }

    if (searchStoreBtn) {
      searchStoreBtn.addEventListener('click', () => this.searchByLocation());
    } else {
      console.error('Search store button not found');
    }

    document.addEventListener('click', (event) => {
      const modal = document.getElementById('store-locator-modal');
      if (modal && modal.classList.contains('open') && !modal.contains(event.target) && !changeStoreBtn.contains(event.target)) {
        this.closeModal();
      }
    });

    console.log('Store locator initialized');
  }
};

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  try {
    StoreLocator.init();
  } catch (error) {
    console.error('Error initializing store locator:', error);
  }
});
  } catch(e) { console.error(e); }
})();

})();
